import { DynamicSchema, RequestItemsSchema } from '@liscio/api';

export const findBalancesItem = (items: RequestItemsSchema[]) => {
  return items.find((item) => {
    return (
      item.item_type === 'dynamic' &&
      (item.dependency?.object as DynamicSchema | undefined)?.type === 'balances'
    );
  });
};
